const Version = () => {
	return <div>Version</div>;
};

export default Version;
